// libraries
import React from 'react';

import { useSelector } from 'react-redux';

// components
import UnknownOcppTagsTable from '../organisms/UnknownOcppTagsTable/UnknownOcppTagsTable';

const UnknownTagListPage = () => {
  return <UnknownOcppTagsTable />;
};

export default UnknownTagListPage;
